import { DragDropElements } from "../elements/DragDropElements";

export class DragDropObserver {
  constructor() {
    this.initializeDragDrop = this.initializeDragDrop.bind(this);
    // Создаем экземпляр MutationObserver
    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Проверяем, является ли добавленный узел контейнером drag-drop
              if (node.matches('.drag-container')) {
                this.initializeDragDrop(node);
              }
              if (node.matches('.draggable')) {
                this.initDraggable(node);
              }

              // Проверяем вложенные элементы на наличие контейнеров drag-drop
              if (typeof node.querySelectorAll !== 'undefined') {
                const dragContainers = node.querySelectorAll('.drag-container');
                dragContainers.forEach((container) => {
                  this.initializeDragDrop(container);
                });
                const draggables = node.querySelectorAll('.drag-container');
                draggables.forEach((element) => {
                  this.initDraggable(element);
                });
              }
            }
          });
        }
      });
    });

    // Начинаем наблюдение за документом
    this.observeDocument();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true // Включаем наблюдение за вложенными элементами
    });

    // Инициализируем DragDropElements для уже существующих контейнеров
    document.querySelectorAll('.drag-container').forEach((container) => {
      this.initializeDragDrop(container);
    });
  }

  initDraggable(element) {
    if (element.dataset.draggableInitialized) return;
    const inputs = element.querySelectorAll('input, textarea, .nodraggable');

    inputs.forEach((input) => {
      input.addEventListener('mouseenter', () => {
        // Сохраняем текущее значение draggable
        element.dataset.originalDraggable = element.getAttribute('draggable');
        // Отключаем draggable
        element.setAttribute('draggable', 'false');
      });

      input.addEventListener('mouseleave', () => {
        // Восстанавливаем значение draggable
        if (element.dataset.originalDraggable !== undefined) {
          element.setAttribute('draggable', element.dataset.originalDraggable);
          delete element.dataset.originalDraggable;
        }
      });
    });

    // Помечаем элемент как инициализированный
    element.dataset.draggableInitialized = true;
  }

  initializeDragDrop(container) {
    // Проверяем, был ли уже инициализирован контейнер
    if (!container.dragDropElements) {
      const dragDropInstance = new DragDropElements(container);
      container.dragDropElements = dragDropInstance;
      container.dataset.dragDropInitialized = true; // Помечаем, что контейнер инициализирован
    }

    if (!container.dataset.draggableInitialized) {
      container.querySelectorAll('.draggable').forEach((element) => {
        this.initDraggable(element);
      });
    }
  }
}